import { toast } from 'react-toastify';
import firebase from '../firebase';
import { customAlert } from './alertActions';
import { clearCart } from './orderqrcart.actions';
import { GET_ORDER_QRCODES, GET_SHIPPERS, ORDER_LOADING } from './types';
export const fetchShipmentDetails = () => async dispatch => {
	await firebase
		.firestore()
		.collection('shipping_details')
		.onSnapshot(query => {
			let tempShippers = [];
			query.forEach(doc => {
				tempShippers.push({ id: doc.id, ...doc.data() });
			});
			dispatch({
				type: GET_SHIPPERS,
				payload: tempShippers,
			});
		});
};
export const getOrderQrCodes = uid => {
	return dispatch => {
		firebase
			.firestore()
			.collection('order_qr_codes')
			.where('user', '==', uid)
			.onSnapshot(query => {
				var tempOrderQrCodes = [];
				query.forEach(doc => {
					tempOrderQrCodes.push({ id: doc.id, ...doc.data() });
				});
				dispatch({
					type: GET_ORDER_QRCODES,
					order_qr_codes: tempOrderQrCodes,
				});
			});
	};
};

export const setOrderLoading = val => async dispatch => {
	dispatch({
		type: ORDER_LOADING,
		payload: val,
	});
};
export const createOrder = payload => async dispatch => {
	dispatch(setOrderLoading(true));
	firebase
		.firestore()
		.collection('order_qr_codes')
		.add(payload)
		.then(async res => {
			await localStorage.removeItem('cart');
			await dispatch(clearCart());
			// await toast.success('Order Created Successfully');
			dispatch(customAlert(true, 'Order Created Successfully'));
			setTimeout(() => {
				dispatch(customAlert(false, ''));
			}, 3000);
			await dispatch(setOrderLoading(false));
			await firebase.firestore().collection('notifications').add({
				type: 'order',
				status: 'placed',
				read: false,
				notify_to: payload.user,
				created_at: firebase.firestore.Timestamp.now(),
			});
			return;
		})
		.catch(err => {
			// toast.warning(err.message);
			dispatch(customAlert(true, err.message));
			setTimeout(() => {
				dispatch(customAlert(false, ''));
			}, 3000);
			dispatch(setOrderLoading(false));
		});
};
